// Phase 14 (2026-06-28) — Centralized PDF preview/download helper.
//
// Why this exists: opening a PDF endpoint with <a href={url} target="_blank">
// does NOT carry the Authorization header — the new tab loads the URL as a
// fresh request and the backend responds with {"detail":"Not authenticated"}.
// Instead we fetch with the bearer token, turn the response into a Blob, and
// then point the browser at a local `blob:` URL (which is not subject to
// auth at all — the data is already in the browser).
//
// All PDF buttons (connected invoices, manual invoices, WHT certificates,
// loan summaries, tax-settings summary, report exports) should go through
// `previewPDF` (open in new tab) or `downloadPDF` (force file save).

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function _token() {
  return localStorage.getItem("st_token") || "";
}

async function _fetchPdfBlob(path) {
  const url = path.startsWith("http") ? path : `${API}${path}`;
  const r = await fetch(url, {
    headers: { Authorization: `Bearer ${_token()}` },
  });
  if (!r.ok) {
    let detail = `${r.status} ${r.statusText}`;
    try {
      const j = await r.json();
      detail = j.detail || detail;
    } catch (_) { /* not JSON */ }
    throw new Error(detail);
  }
  return await r.blob();
}

export async function previewPDF(path) {
  const blob = await _fetchPdfBlob(path);
  const objectUrl = URL.createObjectURL(blob);
  // Open in a new tab. The blob: URL is local, so no auth headers needed.
  const w = window.open(objectUrl, "_blank", "noopener,noreferrer");
  if (!w) {
    // Pop-up blocked → fall back to a triggered download.
    return downloadPDFFromBlob(blob, "preview.pdf", objectUrl);
  }
  // Revoke after a short delay so the new tab has a chance to load.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  return objectUrl;
}

function downloadPDFFromBlob(blob, filename, existingObjectUrl) {
  const objectUrl = existingObjectUrl || URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 5_000);
}

export async function downloadPDF(path, filename) {
  const blob = await _fetchPdfBlob(path);
  downloadPDFFromBlob(blob, filename || "document.pdf");
}
